import { render, staticRenderFns } from "./HistoryActivityDetail.vue?vue&type=template&id=c072df8a&scoped=true&"
import script from "./HistoryActivityDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryActivityDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoryActivityDetail.vue?vue&type=style&index=0&id=c072df8a&lang=scss&scoped=true&"
import style1 from "./HistoryActivityDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c072df8a",
  null
  
)

export default component.exports